import { ERP_COST_MGMT } from 'utils/constants'
import Api from './axiosInstance'

type FetchCostParams = {
  limit: number
  page: number
  search?: string
}

export const fetchCosts = ({ limit, page, search }: FetchCostParams) => {
  const options: any = {}

  if (search) {
    options.search = search
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${ERP_COST_MGMT.ERP_COST}?${params}`,
  })
}

export const exportCost = (date: { from: string; to: string }) => {
  const params = new URLSearchParams(date)

  return Api.post({
    url: `${ERP_COST_MGMT.ERP_COST}/export?${params}`,
  })
}
